import styled from 'styled-components';
import { CalendarPicker } from 'antd-mobile';

export const StyledMobileWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;

    input {
        width: 100%;
        font-size: 16px;
        border-radius: 10px;
        padding: 10px 12px;
    }

    .ant-input-suffix {
        display: flex;
        align-items: center;
    }

    button {
        display: flex;
        align-items: center;
        justify-content: center;
        border: none;
        background: transparent;
        padding: 8px;
        border-radius: 6px;
    }

    @media (max-width: 768px) {
        input {
            font-size: 14px;
            padding: 8px 10px;
        }
    }
`;

export const StyledCalendarMobile = styled(CalendarPicker)`
    --adm-color-primary: ${(props) => props.theme.semantic.primary};
    --adm-color-text: ${(props) => props.theme.semantic.textPrimary};
    --adm-font-size-main: 14px;

    width: 100% !important;
    max-height: 90vh !important;
    overflow-y: auto;
    border-radius: 12px;
    background: ${(props) => props.theme.semantic.surface};
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);

    .adm-popup-body {
        background: ${(props) => props.theme.semantic.surface} !important;
    }
    .adm-calendar-body {
        padding-bottom: 64px;
    }

    .adm-calendar-picker-view-title:not(
            .adm-calendar-picker-view-header .adm-calendar-picker-view-title
        ) {
        background: ${(props) =>
            props.theme.semantic.backgroundLight} !important;
    }

    .adm-calendar-footer {
        position: sticky;
        bottom: 0;
        left: 0;
        right: 0;
        background: ${(props) => props.theme.semantic.surface};
        border-top: 1px solid ${(props) => props.theme.semantic.divider};
        display: flex;
        justify-content: space-between;
        padding: 8px 12px;
        z-index: 10;
    }

    .adm-calendar-day {
        height: 36px !important;
    }

    .adm-calendar-picker-view-cell-selected {
        height: 36px !important;
    }

    .adm-calendar-picker-view-cell-selected-begin {
        border-top-left-radius: 50% !important;
        border-bottom-left-radius: 50% !important;
    }

    .adm-calendar-picker-view-cell-selected-end {
        border-top-right-radius: 50% !important;
        border-bottom-right-radius: 50% !important;
    }

    .adm-calendar-picker-view-cell-top {
        visibility: hidden;
    }
`;
